"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ValidationError extends Error {
    constructor(message, value) {
        super(message);
        this.name = "ValidationError";
        this.value = value;
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=validationError.js.map